'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

require('intersection-observer');

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

/**
 * Wrapper for IntersectionObserver API, useful for inscreen tracking and
 * lazy loading. Defines a specific behavior for observing a collection of
 * elements.
 */
var InscreenObserver = function () {

    /**
     * Define what happens when an element is observed.
     * @callback observationCallback
     * @param {Element} The observed element.
     */

    /**
     * Create an InscreenObserver.
     * @param {observationCallback} callback The callback that handles observations.
     * @param {Object} [options={}] Optional observation behavior.
     * @param {number} [options.proximity=0] Observe elements within [proximity] pixels of the viewport.
     * @param {number} [options.threshold=0] Elements must be visible by a [threshold] fraction before being observed.
     * @param {number} [options.timeout=0] Wait for [timeout] milliseconds before observing elements after entering then viewport.
     * @param {boolean} [options.once=false] If true, observe elements both when entering and exiting the viewport.
     */
    function InscreenObserver(callback) {
        var _this = this;

        var _ref = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
            _ref$proximity = _ref.proximity,
            proximity = _ref$proximity === undefined ? 0 : _ref$proximity,
            _ref$threshold = _ref.threshold,
            threshold = _ref$threshold === undefined ? 0 : _ref$threshold,
            _ref$timeout = _ref.timeout,
            timeout = _ref$timeout === undefined ? 0 : _ref$timeout,
            _ref$once = _ref.once,
            once = _ref$once === undefined ? false : _ref$once;

        _classCallCheck(this, InscreenObserver);

        this._callback = callback;
        this._proximity = proximity;
        this._threshold = threshold;
        this._timeout = timeout;
        this._once = once;
        this._observables = [];
        this._observer = new IntersectionObserver(function (entries) {
            return _this.handleObservations(entries);
        }, {
            rootMargin: proximity + 'px',
            threshold: threshold
        });
    }

    _createClass(InscreenObserver, [{
        key: 'handleObservations',
        value: function handleObservations(entries) {
            var _this2 = this;

            entries.forEach(function (entry) {
                if (_this2.isEnteringViewport(entry)) {
                    _this2.handleOrSetObservationTimeout(entry.target);
                } else {
                    _this2.clearObservationTimeout(entry.target);
                }
            });
        }
    }, {
        key: 'isEnteringViewport',
        value: function isEnteringViewport(entry) {
            return this.isInscreenByThreshold(entry);
        }
    }, {
        key: 'isInscreenByThreshold',
        value: function isInscreenByThreshold(entry) {
            return entry.isIntersecting && entry.intersectionRatio >= this._threshold;
        }
    }, {
        key: 'handleOrSetObservationTimeout',
        value: function handleOrSetObservationTimeout(element) {
            if (this._timeout > 0) {
                this.setObservationTimeout(element);
            } else {
                this.handleObservation(element);
            }
        }
    }, {
        key: 'setObservationTimeout',
        value: function setObservationTimeout(element) {
            var _this3 = this;

            var timeout = setTimeout(function () {
                _this3.handleObservation(element);
            }, this._timeout);
            this.addObservable(element, timeout);
        }
    }, {
        key: 'handleObservation',
        value: function handleObservation(element) {
            this._callback(element);
            if (this._once) {
                this.unobserve(element);
            }
        }
    }, {
        key: 'addObservable',
        value: function addObservable(element, timeout) {
            this._observables.push({ element: element, timeout: timeout });
        }
    }, {
        key: 'clearObservationTimeout',
        value: function clearObservationTimeout(element) {
            var observable = this.removeObservable(element);
            if (observable) {
                clearTimeout(observable.timeout);
            }
        }
    }, {
        key: 'removeObservable',
        value: function removeObservable(element) {
            var isObservedElement = function isObservedElement(observable) {
                return observable.element === element;
            };
            var observable = this._observables.filter(isObservedElement).pop();
            this._observables = this._observables.filter(function (obs) {
                return obs !== observable;
            });
            return observable;
        }

        /**
         * Add an element to observe.
         * @param {Element} element Element to observe
         */

    }, {
        key: 'observe',
        value: function observe(element) {
            this._observer.observe(element);
        }

        /**
         * Remove an observed element.
         * @param {Element} element Element to unobserve
         */

    }, {
        key: 'unobserve',
        value: function unobserve(element) {
            try {
                this._observer.unobserve(element);
            } catch (e) {
                // Fix for throwing TypeMismatchError in Edge 15, originating
                // from the IntersectionObserver polyfill.
            }
            this.clearObservationTimeout(element);
        }

        /**
         * Stop observing elements altogether.
         */

    }, {
        key: 'disconnect',
        value: function disconnect() {
            this._observer.disconnect();
        }
    }]);

    return InscreenObserver;
}();

exports.default = InscreenObserver;